import { $Props } from '@Ravnur-Inc/core/typings/tsx';
import { Vue, Options, prop } from 'vue-class-component';
import CategoriesRepository from '@/repositories/category-repository';
import CheckboxGroup from '@Ravnur-Inc/core/components/checkbox-group/checkbox-group';
import $t from '@Ravnur-Inc/l10n/$t';

import { Category } from '@/types/Category';

import './categories-modal.scss';

const repository = new CategoriesRepository();

class Props {
  selected = prop<Category[]>({ default: [] });
  close = prop<() => void>({ default: () => void 0 });
}

type Emits = {
  onSelect: (selected: Category[]) => void;
};

const CN = 'categories-modal';

@Options({
  name: 'categories-modal',
  emits: ['select', 'update:selected'],
})
export default class CategoriesTreeModal extends Vue.with(Props) {
  declare $props: $Props<Props, Emits, 'selected'>;

  private localSelected: Category[] = this.selected;
  private items: Category[] = [];
  private loading = false;

  render() {
    return (
      <popup
        class={CN}
        header={$t('media', 'field__categories')}
        onClose={this.close}
        onConfirm={this.confirm}
      >
        <scrollable class={`${CN}__scrollable`}>
          {this.loading ? (
            <spinner />
          ) : (
            <CheckboxGroup
              entities={this.items}
              prop="name"
              value={this.localSelected.map((item) => item.id)}
              onInput={this.handleInputEvent}
            />
          )}
        </scrollable>
      </popup>
    );
  }

  handleInputEvent(value: string[]) {
    this.localSelected = this.items.filter((item) => value.includes(item.id));
  }

  private async confirm() {
    this.$emit('select', this.localSelected);
    this.$emit('update:selected', this.localSelected);
    this.close();
  }

  private async load() {
    try {
      this.loading = true;
      const { items } = await repository.load({
        isHidden: false,
        count: 1000,
        offset: 0,
      });

      this.items = items;
    } catch (e) {
      this.$processException(e);
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.load();
  }
}
